import React from "react";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import CustomWizard from "views/Components/CustomWizard.jsx";

import Rules from "./Wizard/Rules.jsx";
import PartnerLinks from "./Wizard/PartnerLinks.jsx";

class IbtreeWizard extends React.Component {

  componentWillMount(){
        if(this.props.match.params.id){
          
        }
      }

  render() {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={10}>
          <CustomWizard
            validate
            steps={[
              { stepName: "Options", stepComponent: Rules, stepId: "rules" },
              { stepName: "Partner Links", stepComponent: PartnerLinks, stepId: "partner-links" },
            ]}
            title=""
            subtitle=""
            color="warning"
            match={this.props.match}
            history={this.props.history}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default IbtreeWizard;


// WEBPACK FOOTER //
// ./src/views/IbTree/Wizard.jsx